import { render, staticRenderFns } from "./config-form.vue?vue&type=template&id=6dc4c69e&scoped=true&"
import script from "./config-form.vue?vue&type=script&lang=js&"
export * from "./config-form.vue?vue&type=script&lang=js&"
import style0 from "./config-form.vue?vue&type=style&index=0&id=6dc4c69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4c69e",
  null
  
)

export default component.exports